/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, ImageList, ImageListItem, Tooltip, Typography } from '@mui/material';
import { theme } from 'theme/theme';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import { IFichaEspectaculo } from 'utils/models/types';
import './GaleriaEspectaculo.scss';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFichaEspectaculoPorId } from 'utils/redux/features/espectaculoFichaSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import PageContainer from 'components/PageContainer/PageContainer';
import Spinner from '../Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';

const GaleriaEspectaculo = ({
  botonVolver,
  espectaculo,
}: {
  botonVolver?: boolean;
  espectaculo?: IFichaEspectaculo;
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const {
    fichaEspectaculo: fichaStore,
    loadingFichaEspectaculo,
    errorFichaEspectaculo,
  } = useSelector((state: RootState) => state.fichaEspectaculo);

  // Decide si usar la prop o la ficha de las props (esto es porque este componente se muestra desde 2 lugares distintos)
  const fichaEspectaculo = espectaculo || fichaStore;
  const fotos = fichaEspectaculo?.Fotos;

  useEffect(() => {
    // Si no hay ficha en las props busca la ficha
    if (id && !espectaculo) {
      dispatch(fetchFichaEspectaculoPorId(Number(id)));
    }
  }, [id, espectaculo]);

  function srcset(image: string, size: number, rows = 1, cols = 1) {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format&dpr=2 2x`,
    };
  }

  return (
    <PageContainer marginBottom={true}>
      {loadingFichaEspectaculo ? (
        <Spinner />
      ) : errorFichaEspectaculo ? (
        <NoResponse />
      ) : (
        <>
          <Box textAlign="left" mx="auto">
            <Typography variant="h3" mb="25px" color={theme.palette.primary.main} fontSize="1.5rem">
              {`Galería de fotos de ${fichaEspectaculo?.Nombre}`}
            </Typography>
          </Box>
          {botonVolver && (
            <Box display="flex" justifyContent="start">
              <Button fullWidth={false} onClick={() => navigate(-1)} startIcon={<ChevronLeft />}>
                Volver
              </Button>
            </Box>
          )}
          <ImageList
            sx={{
              height: '100%',
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)!important',
                md: 'repeat(2, 1fr)!important',
                lg: 'repeat(3, 1fr)!important',
                xl: 'repeat(4, 1fr)!important',
              },
            }}
            variant="quilted"
            rowHeight={250}
          >
            {fotos !== undefined &&
              fotos.map(foto => (
                <Tooltip
                  key={foto}
                  children={
                    <ImageListItem cols={1} rows={1} className="fotoGaleria">
                      <NavLink to={`${foto}`}>
                        <img {...srcset(foto, 121, 1, 1)} alt={fichaEspectaculo?.Nombre} loading="lazy" />
                      </NavLink>
                    </ImageListItem>
                  }
                  title="Ver foto"
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, -140],
                          },
                        },
                      ],
                    },
                  }}
                />
              ))}
          </ImageList>
        </>
      )}
    </PageContainer>
  );
};

export default GaleriaEspectaculo;
